import AboutTab from "../components/AboutPage/AboutTab.js"


export default function Main() {
  return (
    <>
      <AboutTab />
    </>
  );
}